export default "__VITE_ASSET__BQ_wdY02__"